import { API_ROUTES } from '@/api/apiRoutes';
import { Model } from '@/types/nodes/model';
import { safeAxios } from '@/services/safeAxios';
import type { BuiltInModelResponse } from '@/types/api/builtInModel';

/**
 * Splits a Replicate `owner/name` identifier, or null when it carries no owner.
 */
const splitModelId = (modelId: string): { owner: string; name: string } | null => {
  const slashIndex = modelId.indexOf('/');
  if (slashIndex <= 0) {
    return null;
  }
  return { owner: modelId.slice(0, slashIndex), name: modelId.slice(slashIndex + 1) };
};

export const getReplicateModelVersionParams = async (modelToFetch: Model) => {
  const parts = splitModelId(modelToFetch.name);
  const path = parts
    ? API_ROUTES.models.replicateModelVersion({ ...parts, version: modelToFetch.version })
    : API_ROUTES.models.replicateUnownedModelVersion({ modelId: modelToFetch.name, version: modelToFetch.version });
  const res = await safeAxios.get<{ openapi_schema: Record<string, unknown> }>(path);
  return res.data;
};

export const getReplicateModelVersionByName = async (replicateModelId: string) => {
  const parts = splitModelId(replicateModelId);
  const path = parts
    ? API_ROUTES.models.replicateModel(parts)
    : API_ROUTES.models.replicateUnownedModel({ modelId: replicateModelId });
  const res = await safeAxios.get<
    | {
        owner: string;
        name: string;
        description: string;
        cover_image_url: string;
        latest_version: { id: string };
      }
    | BuiltInModelResponse
  >(path);
  return res.data;
};
